import { DialogHandler } from '../../components/dialog/DialogHandler';
import { AbstractBlock } from '../AbstractBlock';
// import route from 'riot-route/lib/tag';
// import { saveBlock } from '../saveBlock';
import { blocklyDispatcher } from '../blocklyDispatcher';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
export class Flicker360ImageButton extends AbstractBlock {
  constructor() {
    super('flicker-360', 'flicker');
    this.title = t.to('Flickrで背景ファイルを選ぶ', 'flickr_title');
    // ワークスペースをマウントしたときにイベントをハンドリング
    blocklyDispatcher.addMountedWorkspaceListener(function (workspace) {
      workspace.registerButtonCallback('click_flicker360', () => {
        DialogHandler.showFlickerDialog();
      });
      blocklyDispatcher.triggerUpdateToolbox(workspace);
    });
  }

  toXml(): HTMLElement {
    const el = document.createElement('button');
    el.setAttribute('text', this.title);
    el.setAttribute('callbackKey', 'click_flicker360');
    el.setAttribute('web-class', 'flicker360');
    return el;
  }
}
